import { render, staticRenderFns } from "./Processamento.vue?vue&type=template&id=1d94cd70&"
import script from "./Processamento.vue?vue&type=script&lang=js&"
export * from "./Processamento.vue?vue&type=script&lang=js&"
import style0 from "./Processamento.vue?vue&type=style&index=0&id=1d94cd70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports